import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  AppInventoryId,
  AppInventoryIdExtensionSchema,
  validateAppInventoryId,
} from './AppInventoryId';

export const AWSWorkloadAppInventoryIdFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AWSWorkload_AppInventoryIdField',
    component: AppInventoryId,
    validation: validateAppInventoryId,
    schema: AppInventoryIdExtensionSchema,
  }),
);
